import { useMsal } from '@azure/msal-react';
import { Bars3Icon } from '@heroicons/react/24/outline';
import React from 'react';
import LogoImage from '../../../assets/images/brightspeed-logo-full-color.png';
import { useAuthCookies } from '../../../hooks/cookie-helper';

// Define the props interface
interface DashboardHeaderProps {
	onSidebarToggle: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ onSidebarToggle }) => {
	const { removeAccessToken } = useAuthCookies();
	const { instance } = useMsal();
	const accounts = instance.getAllAccounts();
	const loggedInUserName = accounts && accounts.length > 0 ? accounts[0].name : '';

	const handleUserNavigation = (action: string) => {
		if (action === 'logout') {
			removeAccessToken();
			instance.logout();
		}
	};

	return (
		<div className="sticky top-0 z-20 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
			{/* Sidebar toggle button (visible on small screens) */}
			<div className="flex items-center lg:hidden">
				<button onClick={onSidebarToggle} className="p-0 text-gray-500 hover:text-gray-900 focus:outline-none">
					<Bars3Icon className="h-6 w-6" aria-hidden="true" />
				</button>
				<div className="ml-2 flex items-center gap-2 text-gray-900 text-md font-bold">
					<img src={LogoImage} width={120} height={20} alt='Brightspeed' />  GenAI</div>
			</div>

			{/* Rest of the header */}
			<div className="flex flex-1 gap-x-2 self-stretch lg:gap-x-6">
				<div className="relative flex flex-1"></div>
				<div className="flex items-center gap-x-2 lg:gap-x-6">
					{/* Display logged in user's name */}
					{loggedInUserName && (
						<button className="text-sm font-semibold truncate w-[100px] lg:w-auto lg:truncate-none">
							{loggedInUserName}
						</button>
					)}

					{/* Logout Button */}
					<button
						type="button"
						onClick={() => handleUserNavigation('logout')}
						className="inline-flex items-center gap-x-1.5 rounded-full bg-[#f8c246] px-3 py-3 text-sm font-semibold text-black shadow-sm hover:bg-[#f8c246] focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-1 focus-visible:outline-[#f8c246]"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							strokeWidth={2.5}
							stroke="currentColor"
							className="w-4 h-4"
						>
							<path strokeLinecap="round" strokeLinejoin="round" d="M5.636 5.636a9 9 0 1 0 12.728 0M12 3v9" />
						</svg>
					</button>
				</div>
			</div>
		</div>
	);
};

export default DashboardHeader;
